<template>
	<div>
		<b-row class="print-row mt-3" v-if="Character.Equipment.Magic.length > 0">
			<b-col class="col">
				<h4 class="avoid-page-break-after">Magic Items</h4>
			</b-col>
		</b-row>
		<b-row class="print-row mt-3" v-for="(item, index) in Character.Equipment.Magic" :key="'details-equipment-magic-'+index">
			<b-col cols="2">
				<strong>{{item.Name}}</strong>
			</b-col>
			<b-col cols="10" class="pre">
				{{item.Description}}
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>